<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">Settings</h2>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Email for send messages</h6>
            </div>
            <div class="table-responsive">
              <div class="section section-service-info">
                <div class="">
                  <div class="service-info">
                    <div class="service-info__preview" v-if="loading">
                      <ValidationObserver ref="settings" id="settings" tag="form" class="d-flex flex-column mt-5" @submit.prevent="formSubmit()">
                        <ValidationProvider v-slot="{ classes }" rules="required"  tag="div" class="d-flex form-group align-items-center">
                          <label class="form-label mr-5 min-vw-150">Email:</label>
                          <input id="video_iframe" class="form-control" name="email" :class="classes" v-model="formData.email" placeholder="Email" type="email">
                        </ValidationProvider>
                        <div class="mt-3 mb-3">
                          <h6 class="main-content-label mb-1">Favicon</h6>
                        </div>
                        <div>
                          <ImageUpload accept="image/png,image/jpeg,image/jpg,image/x-icon" label="Favicon:" name="favicon" uploadType="oneImage" type="image" :validation="true" :filesData="[formData.favicon_path]" />
                        </div>
                        <div class="mt-3 mb-3">
                          <h6 class="main-content-label mb-1">Settings</h6>
                        </div>
                        <ValidationProvider v-slot="{ classes }" rules="required"  tag="div" class="d-flex form-group align-items-center">
                          <label class="form-label mr-5 min-vw-150">Phone:</label>
                          <input id="Phone" class="form-control" name="phone" :class="classes" v-model="formData.phone" placeholder="Phone" type="text">
                        </ValidationProvider>
                        <ValidationProvider v-slot="{ classes }" rules="required"  tag="div" class="d-flex form-group align-items-center">
                          <label class="form-label mr-5 min-vw-150">Support Email:</label>
                          <input id="support_email" class="form-control" name="support_email" :class="classes" v-model="formData.support_email" placeholder="Email" type="email">
                        </ValidationProvider>
                        <ValidationProvider v-slot="{ classes }" rules="required"  tag="div" class="d-flex form-group align-items-center">
                          <label class="form-label mr-5 min-vw-150">Footer Text:</label>
                          <input id="footer_text" class="form-control" name="footer_text" :class="classes" v-model="formData.footer_text" placeholder="Email" type="text">
                        </ValidationProvider>
                        <ValidationProvider v-slot="{ classes }" rules="required"  tag="div" class="d-flex form-group align-items-center">
                          <label class="form-label mr-5 min-vw-150">Facebook URI:</label>
                          <input id="facebook" class="form-control" name="facebook" :class="classes" v-model="formData.facebook" placeholder="Email" type="text">
                        </ValidationProvider>
                        <ValidationProvider v-slot="{ classes }" rules="required"  tag="div" class="d-flex form-group align-items-center">
                          <label class="form-label mr-5 min-vw-150">Whatsapp:</label>
                          <input id="whatsapp" class="form-control" name="whatsapp" :class="classes" v-model="formData.whatsapp" placeholder="Email" type="text">
                        </ValidationProvider>
                        <ValidationProvider v-slot="{ classes }" rules="required"  tag="div" class="d-flex form-group align-items-center">
                          <label class="form-label mr-5 min-vw-150">Waze:</label>
                          <input class="form-control" name="waze" :class="classes" v-model="formData.waze" placeholder="waze" type="text">
                        </ValidationProvider>
                        <button class="btn ripple btn-main-primary">Update</button>
                      </ValidationObserver>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ImageUpload from '../../components/ImageUpload'
export default {
  name: 'Contacts',
  components: {
    ImageUpload
  },
  data () {
    return {
      formData: {
        favicon_path: ''
      },
      loading: false,
      upload: false
    }
  },
  computed: {
    ...mapState({
      settingsList: state => state.settings.settingsList,
      languages: state => state.language.languages
    })
  },
  created () {
    this.getSettingsList().then(() => {
      this.formData = this.settingsList
      this.loading = true
    })
  },
  methods: {
    ...mapActions({
      getSettingsList: 'settings/getSettingsList',
      updateSettings: 'settings/updateSettings'
    }),
    formSubmit () {
      this.$refs.settings.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          const form = document.getElementById('settings')
          const formData = new FormData(form)
          formData.set('id', this.formData.id)
          this.updateSettings({ data: formData }).then(res => {
            this.formData = res
            this.$toasted.success(this.$t('Setting update was successfully!')).goAway(1500)
          }).catch(err => {
            if (err && err.response) {
              if (err.response.status === 422) {
                const data = err.response.data.errors
                const keys = Object.keys(data)
                const msg = data[keys[0]]
                this.$toasted.error(msg).goAway(1500)
              } else {
                this.$toasted.error(err.response.message).goAway(1500)
              }
            }
          }).finally(() => {
            this.buttonDisable = false
          })
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
